var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{attrs:{"icon":"","target":"_blank"},on:{"click":function($event){return _vm.gamePDFLink(_vm.item)}}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("fa-file-pdf")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }